import React from 'react';

import {ChatType} from 'graphql-client/__generated/graphqlGlobalTypes';
import DataCaptureChat from 'llm/data-capture/DataCaptureChat';
import {DeepResearchChat} from 'llm/deep-research/DeepResearchChat';
import {assertNever} from 'util/Types';

/**
 * Delegates rendering to the appropriate chat component based on the chat type.
 *
 * This is logically a part of ChatRouter, but moving it into its own file makes it easier to mock;
 * it also allows new chat type developers from having to grok the ChatRouter internals.
 */
export default function ChatRouterChat({
  chatId,
  chatType,
  isExpanded,
}: {
  chatId: string;
  chatType: ChatType;
  isExpanded: boolean;
}): JSX.Element {
  switch (chatType) {
    case ChatType.DEEP_RESEARCH:
      return <DeepResearchChat chatId={chatId} />;
    case ChatType.DATA_CAPTURE:
      return <DataCaptureChat chatSessionId={chatId} isExpanded={isExpanded} />;
    default:
      throw new Error(`Unexpected chat type: ${assertNever(chatType)}`);
  }
}
